// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"394acbe4","505":"4e953b89","667":"3847ee8c","672":"4e953b89","836":"4e953b89","901":"4e953b89"}[chunkId] + ".chunk.css";
};